import React from 'react';
import cx from 'classnames';
import Icon from '~/core/scripts/components/Icon';

const filters = [
  { label: 'Frauen', value: 'female' },
  { label: 'Männer', value: 'male' },
  { label: 'Gesamt', value: 'total' },
];

const Switcher = ({ onChange, value }) => {
  return (
    <div className="filterbar">
      <div className="btn-group horizontal">
        {filters.map(filter => (
          <button
            onClick={() => onChange(filter.value)}
            value={filter.value}
            className={cx('btn', { active: filter.value === value })}
          >
            {filter.value !== 'total' && (
              <Icon type={filter.value} />
            )}
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Switcher;
